import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { dark } from "@clerk/ui/themes";
import { ptBR } from "@clerk/localizations";

const appearance = {
  theme: dark,
  captcha: { theme: "dark" },
  variables: {
    colorPrimary: "#FFC700",
    colorPrimaryForeground: "#111317",
    colorBackground: "#181B20",
    colorForeground: "#F8FAFC",
    colorInput: "#111317",
    colorInputForeground: "#F8FAFC",
    colorBorder: "rgba(255,255,255,0.14)",
    fontFamily: "Plus Jakarta Sans, sans-serif",
    borderRadius: "0.75rem",
  },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ClerkAuthProvider({ children, initialConfig }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState(initialConfig || null);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    if (initialConfig) return;
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) return cancelled || setConfig(cfg);
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, [initialConfig]);

  if (unavailable) return <p style={{ padding: 24 }}>O login está indisponível no momento. Atualize a página para tentar novamente.</p>;
  if (!config) return <div className="flex min-h-screen items-center justify-center"><div className="h-10 w-10 animate-spin rounded-full border-4 border-[#FFC700] border-t-transparent" /></div>;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      localization={ptBR}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
